<template>
    <div class="o-rotate-device-modal rotate-device-modal">
        <h3 class="rotate-device-modal__heading">
            {{ $t('o-rotate-device-modal__heading') }}
        </h3>
        <span class="rotate-device-modal__text" v-html="$t('o-rotate-device-modal__text')" />
    </div>
</template>

<script>
export default {
    name: 'ORotateDeviceModal'
}
</script>

<style lang="scss">
@import "o-rotate-device-modal";
</style>